<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Noah2</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgments">Acknowledgments</a></li>
<li id="toc-li-5"><a href="#/text/ch005#life-is-not-short">Life Is Not Short</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-one">Chapter One: John</a><ol class="toc"><li id="toc-li-7"><a href="#/text/ch006#john"></a></li>
</ol></li>
<li id="toc-li-8"><a href="#/text/ch007#chapter-two">Chapter Two: Montana – Carol’s Parents’ Farm</a><ol class="toc"><li id="toc-li-9"><a href="#/text/ch007#montana-carols-parents-farm"></a></li>
</ol></li>
<li id="toc-li-10"><span href="#/text/ch008#chapter-three" title="Link target outside of Sample">Chapter Three: The Fourth Universe</span><ol class="toc"><li id="toc-li-11"><span href="#/text/ch008#the-fourth-universe" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-12"><span href="#/text/ch009#chapter-four" title="Link target outside of Sample">Chapter Four: John Is Back to Earth – The First Universe</span><ol class="toc"><li id="toc-li-13"><span href="#/text/ch009#john-is-back-to-earth-the-first-universe" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-14"><span href="#/text/ch010#chapter-five" title="Link target outside of Sample">Chapter Five: John at Tehran Embassy</span><ol class="toc"><li id="toc-li-15"><span href="#/text/ch010#john-at-tehran-embassy" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-16"><span href="#/text/ch011#chapter-six" title="Link target outside of Sample">Chapter Six: Tour Around Persia</span><ol class="toc"><li id="toc-li-17"><span href="#/text/ch011#tour-around-persia" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-18"><span href="#/text/ch012#chapter-seven" title="Link target outside of Sample">Chapter Seven: The Sparks of Hope in the Darkness</span><ol class="toc"><li id="toc-li-19"><span href="#/text/ch012#the-sparks-of-hope-in-the-darkness" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-20"><span href="#/text/ch013#chapter-eight" title="Link target outside of Sample">Chapter Eight: The New Mission</span><ol class="toc"><li id="toc-li-21"><span href="#/text/ch013#the-new-mission" title="Link target outside of Sample"></span></li>
</ol></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?0af722f4